import DataBase.NKAdapter
import Network.Tasks
import Structs.ClientTaxNote
import Structs.ProductDelivery
import Structs.User
import Utils.DatesManipulator
import Utils.NameOptimizer
import commonder.Agent
import commonder.Project
import commonder.SharedApi
import commonder.commonTester
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.async
import kotlinx.coroutines.launch
import mainTester.testYotam

@ExperimentalMultiplatform
fun main() {

    GlobalScope.launch {

    }
    js("if (typeof process !== 'undefined' && process.env) { process.env.NODE_TLS_REJECT_UNAUTHORIZED = \"0\"; }")
    NameOptimizer.dirAdjust("asd")
    JsDB.setActiveDB()
    ProductDelivery
    Tasks.CALCULATE_AMOUNTS_DATA
    ClientTaxNote

    installInteropShims()

    // Expose the same global contract the LEGACY backend produced:
    // window.NiHulKavJsConvertorApp.{JsDB, ApiCallWrapper, ApiChainWrapper, NKTypeConvertor}
    val root: dynamic = js("{}")
    root.JsDB = JsDB
    root.ApiCallWrapper = ApiCallWrapper::class.js
    root.ApiChainWrapper = ApiChainWrapper::class.js
    root.NKTypeConvertor = NKTypeConvertor
    js("(typeof window !== 'undefined' ? window : globalThis)").NiHulKavJsConvertorApp = root
}

fun greet() = "world asdasdasdasd"